<template>
    <span class="stars col-xs-12 col-sm-6 no-padding" @mouseleave="stopHover">
        <template v-for="index in 5">
            <span v-if="hoverTillStar >= index" :key="index" class="star active" @mouseover="hoverStars(index)">
                <a :href="link"><i class="icon hep-stars1"></i></a>
            </span>
            <span v-else :key="index" class="star" @mouseover="hoverStars(index)">
                <a :href="link"><i class="icon hep-stars1"></i></a>
            </span>
        </template>
    </span>
</template>

<script>
    export default {
        props: ['link'],
        data: function () {
            return {
                hover: false,
                hoverTillStar: 0,
            }
        },
        methods: {
            hoverStars: function (star) {
                this.hover = true;
                this.hoverTillStar = star;
            },
            stopHover: function () {
                this.hover = false;
                this.hoverTillStar = 0;
            },
        },
    };
</script>

<style scoped>
    .stars {
        height: 50px;
        display: inline;
    }
    .star {
        width: 50px;
        height: 50px;
        display: block;
        float: left;
        font-size: 150px;
        position: relative;
        color: #d8d8d8;
        overflow: hidden;
    }

    .star a {
        color: inherit;
    }

    .star.active {
        color: #ffd680;
    }

    .hep-stars1:before {
        position: relative;
        left: -50px;
        top: -95px;
        width: 50px;
        height: 50px;
    }

    @media all and (max-width: 767px) {
        .hep-stars1:before {
            top: -49px;
            left: calc(50% - 75px);
        }

        .star {
            width: 20%;
        }
    }

    @media all and (min-width: 768px) {
        .stars {
            width: initial;
        }
    }
</style>